import React, {Suspense, useState} from 'react';
import Layout from "./containers/Layout/Layout";
import SeedChecker from "./containers/SeedChecker/SeedChecker";
import { HashRouter, Route, Switch } from "react-router-dom";
import EventViewer from './containers/EventViewer/EventViewer';
import Event from "./containers/EventViewer/Event/Event";
import { useTranslation } from 'react-i18next';
import DenOverview from "./containers/DenOverview/DenOverview";
import DenDetail from './containers/DenOverview/DenDetail';
//import DenMap from "./Map"; 
import DenMap from "./containers/DenMap/DenMap";
import Underground from "./containers/Underground/UndergroundOverview";

function App() {
  // eslint-disable-next-line
  const { t, i18n } = useTranslation();
  const [render, setRender] = useState(false);

  const changeLanguage = lng => {
      i18n.changeLanguage(lng);
      setRender(prev => !prev);
  };
  
  return (
    <Suspense fallback="loading">
      <HashRouter basename="/">
        <Layout changeLanguage={changeLanguage}>
          <Switch>
              {/*<Route path="/" component={DenMap} />*/}
              <Route path="/" exact><SeedChecker rerender={render} /></Route>
              <Route path="/dens/" exact><DenOverview rerender={render} /></Route>
              <Route path="/dens/:id"><DenDetail rerender={render} /></Route>
              <Route path="/event/" exact><EventViewer rerender={render} /></Route>
              <Route path="/event/:id"><Event rerender={render} /></Route>
              <Route path="/maps/"><DenMap rerender={render} /></Route>
              <Route path="/adventure/"><DenMap rerender={render} /></Route>
              {/*<Route path="/underground/"><Underground rerender={render} /></Route>*/}
          </Switch>
        </Layout>
      </HashRouter>
    </Suspense>
  );
}

export default App;
